import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import ParticleBoard from './ParticleBoard';

export default class SnowParticle extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {ParticleBoard} parentRef
   * @param {integer} x
   * @param {number} y
   * @param {string} texture
   * @param {string} atlas
   */
  constructor(scene, parentRef, x = 0, y = 0, texture = 'Particle_1', atlas = ABCyaPhaser.Images.DEFAULT_ATLAS) {
    super(scene, x, y, atlas, texture);

    this.parentRef = parentRef;
    this.speed = null;
    this.x = null;
    this.y = -20;
    this.destY = null;
    this.alpha = 1;
    this.scaleX = 1;
    this.scaleY = 1;
    this.visible = false;

    this.parentRef.add(this);
  }

  reset(spritename, speed, startX, endY, a, scale) {
    this.speed = speed;
    this.x = startX;
    this.destY = endY;
    this.alpha = a;
    this.scaleX = scale;
    this.scaleY = scale;
    this.y = -20;
    this.visible = true;
    this.setFrame(spritename);
  };

  tick(d) {
    this.y += this.speed * d / 1000;
    if (this.y > this.destY) {
      this.parentRef.resetParticle(this);
    }
  };
}